import { render, staticRenderFns } from "./AutoInspectionEtape2.vue?vue&type=template&id=22a2e624"
import script from "./AutoInspectionEtape2.vue?vue&type=script&lang=js"
export * from "./AutoInspectionEtape2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports